<script setup>

const props = defineProps({
  reportType: {
    type: String,
    required: true,
    validator: (value) => ['student', 'teacher', 'principal', 'parent'].includes(value),
  },
  reportData: {
    type: Object,
    default: () => ({     
        schoolName: '',
        studentName: '',
        studentNum: '',
        studentGender: '',
        grade: '',
        className: '',
        totalStudent: '',
        teacherName: '',
        date: '',
        schul_type: '', // 학교급 추가
    }),
  },
});
</script>

<template>   
  <h3 class="report-title pt-6">
    AI·디지털 리터러시 진단 결과
    <span v-if="props.reportType === 'student'">(학생용)</span>
    <span v-if="props.reportType === 'teacher'">(학급용)</span>
    <span v-if="props.reportType === 'principal'">(학교용)</span>
  </h3>
  <div class="info"> 
    <template v-if="props.reportType ===  'student' || props.reportType === 'parent'">      
      <p><span>학교</span>{{ props.reportData.schoolName }}</p> 
      <p><span>학생</span>{{ props.reportData.grade }}학년 {{ props.reportData.className }}반 {{ props.reportData.studentNum }}번 {{ props.reportData.studentName }}</p>        
    </template>
    <template v-else-if="props.reportType === 'teacher'">         
      <p><span>학교</span>{{ props.reportData.schoolName }}</p>   
      <p><span>학급</span>{{ props.reportData.grade }}학년 {{ props.reportData.className }}반</p> 
      <p><span>담임</span>{{ props.reportData.teacherName }}</p> 
    </template>      
    <template v-else-if="props.reportType === 'principal'">         
      <p style="min-width: auto; text-align: center; display: block;">{{ props.reportData.schoolName }}</p>    
    </template>    
  </div>  
  <div class="ai-intro pb-3">
    <h4 class="title-box">AI·디지털 리터러시 진단검사 개요</h4>
    <div class="ai-table pt-1">
      <div class="row">
          <div class="th"><span>정의</span></div>
          <div class="td">‘AI·디지털 리터러시’ 란 일상생활과 교과학습의 기반이 되는 기초역량으로서 A·I 디지털 기술에 대한 이해를 바탕으로 문제를 해결하고, AI·디지털 기술을 책임감 있고 올바르게 활용하고 평가하는 능력을 뜻합니다.</div>
      </div>
      <div class="row">
          <div class="th"><span>검사 목적</span></div>
          <div class="td">서울 학생 AI·디지털 리터러시 진단 검사는 학생들에게 AI·디지털 리터러시 학생 수준 진단 및 맞춤형 정보를 제공하고 AI·디지털 학습 환경 적응을 위한 학생 맞춤 지원을 하기 위함입니다.</div>
      </div>
    </div>
  </div>

  <div class="card-wrap">
    <div class="card area-guide">
      <h5 class="card-title">AI·디지털 리터러시 영역 안내</h5>
      <div class="ai-table pt-2 pb-5">
        <div class="row">
          <div class="th">
            <img src="@/assets/images/result/ai/icon_01.svg">
            <p>AI·디지털 기술</p>
          </div>
          <div class="td">인공지능의 정의, 기계학습과 생성형 인공지능의 특징과 주요원리를 이해하고, 인공지능 기술에 흥미와 관심을 갖고 탐구하는 태도를 실천함.</div>
        </div> 
        <div class="row">
          <div class="th">
            <img src="@/assets/images/result/ai/icon_02.svg">
            <p>AI·디지털 활용</p>
          </div>
          <div class="td">문제 해결, 협업, 콘텐츠 창작, 학습 및 탐구 등 다양한 목적을 위해 인공지능 도구를 적절히 활용하고, 인공지능의 결과를 비판적으로 검토하며 올바른 활용습관을 실천함.</div>
        </div> 
        <div class="row">
          <div class="th">
            <img src="@/assets/images/result/ai/icon_03.svg">
            <p>AI·디지털 윤리</p>
          </div>
          <div class="td">인공지능의 영향과 윤리적 문제를 이해하고, AI·디지털 기술을 주체적이고 책임감 있게 사용하고 지속 가능한 발전을 도모하는 태도를 갖고 실천함.</div>
        </div> 
        <div class="row">
          <div class="th">
            <img src="@/assets/images/result/ai/icon_04.svg">
            <p>인간 중심 AI 설계</p>
          </div>
          <div class="td">인공지능이 본래 목적과 가치에 부합하는지 탐색하고, 인간과 인공지능의 차이에 대한 이해를 바탕으로 인공지능과의 효과적인 협업전략을 탐색하는 태도를 갖고 실천함.</div>
        </div> 
      </div>
    </div>
<!-- 학교급에 따라 하위영역 바뀌게 -->
    <template v-if="props.reportData.schul_type === 'E'">
      <div class="card sub-area">
        <h5 class="card-title">AI·디지털 리터러시 하위 영역</h5>
        <div class="ai-table pt-2">
          <div class="row">
            <div class="th">
              <div class="icon-wrap">
                <img src="@/assets/images/result/ai/icon_01.svg">
                <span>AI·디지털 기술</span>
              </div>           
              <p>
                <span>인공지능 기초</span>
                <span>기계학습과 딥러닝</span>
                <span>생성형 인공지능</span>
              </p>
            </div>
            <div class="td">
              <div class="icon-wrap">
                <img src="@/assets/images/result/ai/icon_02.svg">
                <span>AI·디지털 활용</span>
              </div>            
              <p>
                <span>문제 해결</span>
                <span>콘텐츠 창작</span>
                <span>학습 및 탐구</span>
              </p>            
            </div>
          </div>
          <div class="row">
            <div class="th">
              <div class="icon-wrap">
                <img src="@/assets/images/result/ai/icon_03.svg">
                <span>AI·디지털 윤리</span>
              </div>            
              <p>
                <span>사회적 영향</span>
                <span>주체성과 안전한 사용</span>
                <span>책임감 있는 사용</span>
              </p>            
            </div>
            <div class="td">
              <div class="icon-wrap">
                <img src="@/assets/images/result/ai/icon_04.svg">
                <span>인간 중심 AI 설계</span>
              </div>            
              <p>
                <span>인간중심 AI 설계</span>
                <span>AI생애주기</span>
              </p>
            </div>
          </div>       
        </div>
      </div>
    </template>
    <!-- 중등-->
    <template v-else>
      <div class="card sub-area">
        <h5 class="card-title">AI·디지털 리터러시 하위 영역</h5>
        <div class="ai-table pt-2">
          <div class="row">
            <div class="th">
              <div class="icon-wrap">
                <img src="@/assets/images/result/ai/icon_01.svg">
                <span>AI·디지털 기술</span>
              </div>           
              <p>
                <span>인공지능 기초</span>
                <span>기계학습과 딥러닝</span>
                <span>생성형 인공지능</span>
              </p>
            </div>
            <div class="td">
              <div class="icon-wrap">
                <img src="@/assets/images/result/ai/icon_02.svg">
                <span>AI·디지털 활용</span>
              </div>            
              <p>
                <span>문제 해결</span>
                <span>콘텐츠 창작</span>
                <span>학습 및 탐구</span>
              </p>            
            </div>
          </div>
          <div class="row">
            <div class="th">
              <div class="icon-wrap">
                <img src="@/assets/images/result/ai/icon_03.svg">
                <span>AI·디지털 윤리</span>
              </div>            
              <p>
                <span>사회적 영향</span>
                <span>주체성과 안전한 사용</span>
                <span>책임감 있는 사용</span>
              </p>            
            </div>
            <div class="td">
              <div class="icon-wrap">
                <img src="@/assets/images/result/ai/icon_04.svg">
                <span>인간 중심 AI 설계</span>
              </div>            
              <p>
                <span>인간중심 AI 설계</span>
                <span>AI생애주기</span>
              </p>
            </div>
          </div>       
        </div>
      </div>
    </template>
    <div class="character">
      <img src="@/assets/images/result/ai/char_01.png">
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .report-title {
    font-family: var(--smoe-font-visual);
    font-size: 2.5rem;
    font-weight: 700;
    text-align: center;
    padding-bottom: 1.125rem;
  }
  .info {
    border: 1px solid var( --result-ai-border);
    border-radius: .375rem;
    max-width: 600px;
    padding: 1.25rem 2.188rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr); 
    /* justify-items: start; */
    justify-content: center;
    margin: 0 auto 1.5rem;
    row-gap: .938rem;
    /* text-align: center; */
    p { 
      display: flex;
      align-items: center;    
      justify-content: flex-start;      
      justify-self: center; 
      /* width: fit-content; 
      min-width: 220px;   */
      width: 250px;    
      span { 
        font-weight: 700; 
        color: var(--result-ai-primary-800); 
        padding-right: 1.5rem;        
        flex-shrink: 0;
        text-align: left;
      }     
      &:first-child:nth-last-child(2),
      &:first-child:nth-last-child(2) ~ p {
        grid-column: 1 / -1;
      }      
      &:only-child {
        grid-column: 1 / -1;
      }
    }
  }

  .ai-intro {
    .ai-table { 
      .th {  
        padding: .5rem;
        span {
          font-size: 1.5rem; 
          font-weight: 700; 
          color: var(--result-ai-primary-800); 
          background-color: var( --result-ai-primary-50);
          border-radius: .25rem;
          width: 115px;
          height: 80px;
          display: flex;
          justify-content: center;
          align-items: center;       
        }
      }      
      .td { 
        font-size: 1.25rem; 
        padding: 1.5rem .75rem; 
        text-align: justify; 
        word-break: keep-all;
        text-justify: inter-word;
      }
    } 
  }

  .area-guide {
    .ai-table .row > div {       
      &.th {
        gap: 1rem; padding: .5rem 1.5rem; justify-content: flex-start;
        img { width: 100px; }
        p { text-align: center; flex: 1; font-weight: 700; color: var(--result-ai-primary-800); }
      }
      &.td { 
        padding: 1.5rem 2rem; 
        line-height: 1.6; 
        display: flex; 
        align-items: center; 
        justify-content: center; 
        text-align: justify;
        word-break: keep-all;
        text-justify: inter-word;
      }
    }
  }

  .sub-area {
    .ai-table {
      display: flex;   
      flex-direction: column;
      width: 100%;
      .row { 
        display: flex; 
        .th, .td { 
          width: 50%; 
          display: flex; 
          justify-content: center;
          align-items: center;
          padding: .5rem 2rem 1rem;
          > div {
            width: 40%; 
            img { width: 100px; }
          }
          > p { width: 60%; }
        }
        .th { justify-content: space-between; }
      }  
      .icon-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
        span {
          font-weight: 700;
          color: var(--result-ai-primary-800);
          padding-top: .5rem;     
        }
      }
      p {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 235px;   
        padding-right: 2.375rem;       
        span { 
          border-bottom: 1px solid var(--result-ai-border); 
          width: 100%;
          text-align: center;
          padding: .25rem 0 ; 
          &:last-child { border: 0; }
        }
      }
    }
  }
  .character { position: absolute; right: 0; bottom: 0; }
</style>